module.exports = __webpack_public_path__ + "img/linux-basic.f4aa5758.png";